module.exports = __webpack_public_path__ + "img/result_txt_cb.0c3d53b4.png";